import { DataBean } from "../../DataBean";


export class ConsecutiveSequence extends DataBean {

    public async createEntityConsecutiveSequence(idTaxEntityConsecutive: any, actualConsecutive: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.dev.Sequence_createEntityConsecutiveSequence_Number_Number", [idTaxEntityConsecutive, actualConsecutive]);
    }

}